import { FixedSizeFitContainer, ResponsiveView } from "../singlegame/ResponsiveHelpers";
import { GetOrientation, Orientation } from "./FitScreen";
import { MainContainerSize } from "./IJackpotDisplayPIXIAPPResponsive";
import { JackpotDisplayDiamondPotResponsivePIXIAPP } from "./JackpotDisplayDiamondPotResponsivePIXIAPP";
import { Geometry, Rect, Scale } from "./MyHelpers";
import * as PIXI from 'pixi.js';

export class JackpotDisplayDiamondPotResponsivePIXIAPPHorizontal extends JackpotDisplayDiamondPotResponsivePIXIAPP {
	

}